import BookingAppSocketIOContext from "./BookingAppSocketIO.context"

import { useContext } from "react"

const useBookingAppSocketIOContext = () => {
  return useContext(BookingAppSocketIOContext)
}

export default useBookingAppSocketIOContext
